import { Component, ChangeDetectionStrategy } from '@angular/core';
import { OutlookMsalService } from '@maximizer/outlook/shared/data-access';
import { TranslatePipe } from '@ngx-translate/core';
import { OUTLOOK_SHARED_UI } from '@maximizer/outlook/shared/ui';
import { TrackEventService } from '@maximizer/core/shared/data-access';
import {
  EventAction,
  EventJourney,
  EventModule,
} from '@maximizer/outlook/shared/domain';

@Component({
  selector: 'maximizer-outlook-msal-mismatch-error',
  template: `<maximizer-outlook-status-message
    [type]="'error'"
    [message]="'outlook.auth.msal.mismatchError' | translate"
    [actionText]="'outlook.buttons.switch' | translate"
    (action)="switchAccount()"
    [actionButtonId]="'outlook-auth-msal-mismatchError-switch'"
  >
  </maximizer-outlook-status-message>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, OUTLOOK_SHARED_UI],
})
export class MsalMismatchErrorComponent {
  constructor(
    private readonly msalService: OutlookMsalService,
    private readonly tracker: TrackEventService,
  ) {}

  switchAccount(): void {
    this.tracker.trackEvent({
      module: EventModule.Notification,
      journey: EventJourney.StatusMessage,
      action: EventAction.Clicked,
      metadata: {
        event: 'switch-account',
        type: 'microsoft-account-mismatch',
      },
    });

    this.msalService.switchAccount();
  }
}
